import { createContext, useContext, useMemo, useState, useEffect, useCallback, type ReactNode } from "react";

export const CATEGORIES = [
  "All Categories",
  "Cars",
  "Bikes",
  "Mobiles",
  "Real Estate",
  "House Rents / Room Mates",
  "Bus / Trucks / Autos / Other Vehicles",
  "Automobile Accessories",
  "Pets & Hobbies",
  "Community & Events",
  "Furniture / Interiors",
  "Electronics & Appliances",
  "Personal & Community",
  "Jobs & Services",
  "Fashion & Lifestyle",
  "Safety / Protection",
  "Business / Financial",
  "Professional Services / Trades",
  "Insurance / Legal",
  "Maintenance & Repair",
  "Personal Services",
  "Sales / Auctions / Discounts",
  "Gifts / Special Occasions",
  "Travel / Entertainment",
  "Water Filtration / Purification",
  "Security Guards",
  "Other Services",
] as const;

export const POPULAR_CITIES = [
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Chennai",
  "Kolkata",
  "Hyderabad",
  "Pune",
  "Ahmedabad",
  "Jaipur",
  "Chandigarh",
  "Kochi",
  "Indore",
  "Bhopal",
  "Lucknow",
  "Kanpur",
  "Nagpur",
  "Coimbatore",
  "Madurai",
  "Trichy",
  "Vijayawada",
  "Visakhapatnam",
  "Guntur",
  "Warangal",
  "Nizamabad",
  "Surat",
  "Vadodara",
  "Rajkot",
  "Patna",
  "Ranchi",
  "Bhubaneswar",
  "Cuttack",
  "Guwahati",
  "Shillong",
  "Agartala",
  "Imphal",
  "Aizawl",
  "Gangtok",
  "Dehradun",
  "Shimla",
  "Jammu",
  "Srinagar",
] as const;

export const OTHER_CITIES = [
  "Aalo",
  "Abohar",
  "Abu Road",
  "Achampet",
  "Acharapakkam",
  "Addanki",
  "Adilabad",
  "Adimali",
  "Adipur",
  "Adoni",
  "Agar Malwa",
  "Agiripalli",
  "Agra",
  "Ahilyanagar",
  "Ahmedgarh",
  "Ahore",
  "Ajmer",
  "Akaltara",
  "Akbarpur",
  "Akividu",
  "Akluj",
  "Akola",
  "Akot",
  "Alakode",
  "Alangudi",
  "Alangulam",
  "Alappuzha",
  "Alathur",
  "Alibaug",
  "Aligarh",
  "Alipurduar",
  "Allagadda",
  "Allahabad",
  "Almora",
  "Amalapuram",
  "Amaravati",
  "Ambajogai",
  "Ambala",
  "Ambikapur",
  "Amdavad",
  "Amravati",
  "Amreli",
  "Amritsar",
  "Amroha",
  "Anakapalle",
  "Anand",
  "Anantapur",
  "Angamaly",
  "Angul",
  "Arambagh",
  "Arangal",
  "Arrah",
  "Asansol",
  "Aurangabad",
  "Azamgarh",
  "Bagalkot",
  "Bahadurgarh",
  "Balangir",
  "Balasore",
  "Ballari",
  "Ballia",
  "Balod",
  "Balrampur",
  "Banda",
  "Bankura",
  "Banswara",
  "Baramati",
  "Baramulla",
  "Bardhaman",
  "Bareilly",
  "Bargarh",
  "Baripada",
  "Barnala",
  "Barshi",
  "Barwani",
  "Basirhat",
  "Bathinda",
  "Beawar",
  "Begusarai",
  "Belagavi",
  "Berhampur",
  "Bettiah",
  "Betul",
  "Bhagalpur",
  "Bhandara",
  "Bharatpur",
  "Bharuch",
  "Bhavnagar",
  "Bhilai",
  "Bhilwara",
  "Bhimavaram",
  "Bhiwani",
  "Bhuj",
  "Bid",
  "Bidar",
  "Bilaspur",
  "Bokaro",
  "Bongaigaon",
  "Budaun",
  "Bulandshahr",
  "Burhanpur",
  "Buxar",
  "Calicut",
  "Chamba",
  "Champa",
  "Chandauli",
  "Chandrapur",
  "Chapra",
  "Chatra",
  "Chengalpattu",
  "Chhatarpur",
  "Chhindwara",
  "Chidambaram",
  "Chikkaballapur",
  "Chikkamagaluru",
  "Chinsurah",
  "Chirala",
  "Chittoor",
  "Chittorgarh",
  "Churu",
  "Cuddalore",
  "Dahod",
  "Daltonganj",
  "Daman",
  "Damoh",
  "Darbhanga",
  "Darjeeling",
  "Dausa",
  "Davangere",
  "Deoghar",
  "Deoria",
  "Dewas",
  "Dhanbad",
  "Dhar",
  "Dharmapuri",
  "Dharwad",
  "Dhule",
  "Dibrugarh",
  "Diu",
  "Dimapur",
  "Dindigul",
  "Durg",
  "Durgapur",
  "Eluru",
  "Erode",
  "Etah",
  "Etawah",
  "Faizabad",
  "Faridabad",
  "Faridkot",
  "Fatehpur",
  "Firozabad",
  "Firozpur",
  "Gadag",
  "Gadchiroli",
  "Gadwal",
  "Gandhinagar",
  "Gangapur",
  "Gaya",
  "Godhra",
  "Gonda",
  "Gondia",
  "Gopalganj",
  "Gorakhpur",
  "Gudivada",
  "Gudur",
  "Gulbarga",
  "Guna",
  "Guntakal",
  "Gurdaspur",
  "Gurugram",
  "Gwalior",
  "Habra",
  "Hajipur",
  "Haldwani",
  "Hamirpur",
  "Hanumangarh",
  "Hapur",
  "Hardoi",
  "Haridwar",
  "Hassan",
  "Hathras",
  "Haveri",
  "Hazaribagh",
  "Hinganghat",
  "Hingoli",
  "Hisar",
  "Hoshiarpur",
  "Hospet",
  "Hosur",
  "Hubli",
  "Jabalpur",
  "Jagdalpur",
  "Jagtial",
  "Jalandhar",
  "Jalgaon",
  "Jalna",
  "Jamshedpur",
  "Jaunpur",
  "Jhajjar",
  "Jhalawar",
  "Jhansi",
  "Jharsuguda",
  "Jind",
  "Jodhpur",
  "Jorhat",
  "Junagadh",
  "Kadapa",
  "Kaithal",
  "Kakinada",
  "Kalaburagi",
  "Kalyan-Dombivli",
  "Kamareddy",
  "Kanchipuram",
  "Kandukur",
  "Kannur",
  "Kapurthala",
  "Karad",
  "Karimnagar",
  "Karnal",
  "Karur",
  "Kasaragod",
  "Katni",
  "Kavali",
  "Kendrapara",
  "Keonjhar",
  "Khammam",
  "Khandwa",
  "Kharagpur",
  "Kheda",
  "Kishanganj",
  "Kohima",
  "Kolhapur",
  "Kollam",
  "Korba",
  "Kota",
  "Kothagudem",
  "Kottayam",
  "Krishnagiri",
  "Kumbakonam",
  "Kurnool",
  "Kurukshetra",
  "Lakhimpur Kheri",
  "Latur",
  "Loni",
  "Ludhiana",
  "Machilipatnam",
  "Mahbubnagar",
  "Mahasamund",
  "Mainpuri",
  "Malappuram",
  "Malda",
  "Mancherial",
  "Mandi",
  "Mandya",
  "Mangaluru",
  "Mango",
  "Mandsaur",
  "Maripeda",
  "Mathura",
  "Medak",
  "Medinipur",
  "Meerut",
  "Mehsana",
  "Mirzapur",
  "Moga",
  "Moradabad",
  "Morbi",
  "Morena",
  "Motihari",
  "Muktsar",
  "Munger",
  "Murwara",
  "Muzaffarnagar",
  "Muzaffarpur",
  "Mysuru",
  "Nagarcoil",
  "Nagaur",
  "Nagda",
  "Nagercoil",
  "Naihati",
  "Nalgonda",
  "Namakkal",
  "Nanded",
  "Nandigama",
  "Nandurbar",
  "Nandyal",
  "Narasaraopet",
  "Narsinghpur",
  "Nashik",
  "Navi Mumbai",
  "Nawada",
  "Neemuch",
  "Nellore",
  "Nilanga",
  "Nirmal",
  "Nuzvid",
  "Ongole",
  "Osmanabad",
  "Ozhukarai",
  "Palakkad",
  "Palanpur",
  "Pali",
  "Palwal",
  "Panaji",
  "Panchkula",
  "Panipat",
  "Panvel",
  "Parbhani",
  "Patan",
  "Pathankot",
  "Patiala",
  "Peddapalli",
  "Phagwara",
  "Pilibhit",
  "Pithampur",
  "Pithapuram",
  "Porbandar",
  "Proddatur",
  "Puducherry",
  "Pudukkottai",
  "Puri",
  "Purnia",
  "Qadian",
  "Qazigund",
  "Quilon",
  "Raichur",
  "Raigarh",
  "Raipur",
  "Rajahmundry",
  "Rajapalayam",
  "Rajnandgaon",
  "Rajsamand",
  "Ramagundam",
  "Ramgarh",
  "Rampur",
  "Ratlam",
  "Ratnagiri",
  "Rewa",
  "Rewari",
  "Robertson Pet",
  "Roha",
  "Rohtak",
  "Roorkee",
  "Rourkela",
  "Sagar",
  "Saharanpur",
  "Saharsa",
  "Salem",
  "Sambalpur",
  "Sambhal",
  "Sangamner",
  "Sangli",
  "Sangola",
  "Sasaram",
  "Satara",
  "Satna",
  "Sawai Madhopur",
  "Sehore",
  "Shahjahanpur",
  "Shivamogga",
  "Shivpuri",
  "Sikar",
  "Silchar",
  "Siliguri",
  "Silvassa",
  "Singrauli",
  "Sircilla",
  "Sirsa",
  "Sirsi",
  "Sitapur",
  "Siwan",
  "Solapur",
  "Sonipat",
  "Sri Ganganagar",
  "Srikakulam",
  "Sultanpur",
  "Surendranagar",
  "Suryapet",
  "Tadepalligudem",
  "Tadpatri",
  "Tezpur",
  "Thalassery",
  "Thane",
  "Thanjavur",
  "Thoothukudi",
  "Thiruvananthapuram",
  "Thrissur",
  "Tinsukia",
  "Tirunelveli",
  "Tirupati",
  "Tiruppur",
  "Tiruvallur",
  "Tiruvottiyur",
  "Tonk",
  "Tumakuru",
  "Tura",
  "Udaipur",
  "Ujjain",
  "Ulhasnagar",
  "Unnao",
  "Udupi",
  "Varanasi",
  "Vasai-Virar",
  "Vellore",
  "Veraval",
  "Vidisha",
  "Villupuram",
  "Waidhan",
  "Wardha",
  "Washim",
  "Xeldem",
  "Yamuna Nagar",
  "Yavatmal",
  "Zaheerabad",
  "Zira",
  "Zirakpur",
  "Ziro",
  "Zunheboto",
] as const;

export const CITIES = [
  "All India",
  ...POPULAR_CITIES,
  ...OTHER_CITIES,
] as const;

export type Category = (typeof CATEGORIES)[number];
export type City = (typeof CITIES)[number];

const CITY_STORAGE_KEY = "memads_selected_city";

// Common alternate names / aliases that map to our CITIES list
const CITY_ALIASES: Record<string, string> = {
  // Karnataka
  "bangalore": "Bengaluru",
  "bengalooru": "Bengaluru",
  "bangalore urban": "Bengaluru",
  "bangalore rural": "Bengaluru",
  "bengaluru urban": "Bengaluru",
  "bengaluru rural": "Bengaluru",
  "bangalore metropolitan": "Bengaluru",
  "bengaluru metropolitan": "Bengaluru",
  "electronic city": "Bengaluru",
  "whitefield": "Bengaluru",
  "mysore": "Mysuru",
  "hubballi": "Hubli",
  "hubli-dharwad": "Hubli",
  "belgaum": "Belagavi",
  "mangalore": "Mangaluru",
  "gulbarga": "Kalaburagi",
  "shimoga": "Shivamogga",
  "tumkur": "Tumakuru",
  "bellary": "Ballari",
  "bijapur": "Vijayapura",

  // Maharashtra
  "bombay": "Mumbai",
  "greater mumbai": "Mumbai",
  "mumbai suburban": "Mumbai",
  "mumbai city": "Mumbai",
  "mumbai metropolitan": "Mumbai",
  "navi mumbai": "Mumbai",
  "thane": "Mumbai",
  "kalyan": "Mumbai",
  "dombivli": "Mumbai",
  "kalyan-dombivli": "Mumbai",
  "vasai": "Mumbai",
  "virar": "Mumbai",
  "vasai-virar": "Mumbai",
  "poona": "Pune",
  "pune district": "Pune",
  "pune metropolitan": "Pune",
  "pimpri": "Pune",
  "chinchwad": "Pune",
  "pimpri-chinchwad": "Pune",
  "pimpri chinchwad": "Pune",
  "pcmc": "Pune",
  "hinjewadi": "Pune",
  "ahmednagar": "Ahilyanagar",
  "aurangabad": "Aurangabad",
  "chhatrapati sambhajinagar": "Aurangabad",

  // Delhi NCR
  "new delhi": "Delhi",
  "delhi ncr": "Delhi",
  "national capital territory of delhi": "Delhi",
  "nct of delhi": "Delhi",
  "central delhi": "Delhi",
  "east delhi": "Delhi",
  "new delhi district": "Delhi",
  "north delhi": "Delhi",
  "north east delhi": "Delhi",
  "north west delhi": "Delhi",
  "south delhi": "Delhi",
  "south east delhi": "Delhi",
  "south west delhi": "Delhi",
  "west delhi": "Delhi",
  "shahdara": "Delhi",
  "gurgaon": "Delhi",
  "gurugram": "Delhi",
  "noida": "Delhi",
  "greater noida": "Delhi",
  "faridabad": "Delhi",
  "ghaziabad": "Delhi",

  // Telangana
  "secunderabad": "Hyderabad",
  "cyberabad": "Hyderabad",
  "greater hyderabad": "Hyderabad",
  "hyderabad district": "Hyderabad",
  "hyderabad metropolitan": "Hyderabad",
  "rangareddy": "Hyderabad",
  "ranga reddy": "Hyderabad",
  "ranga reddy district": "Hyderabad",
  "rangareddy district": "Hyderabad",
  "medchal": "Hyderabad",
  "medchal-malkajgiri": "Hyderabad",
  "medchal malkajgiri": "Hyderabad",
  "sangareddy": "Hyderabad",
  "kukatpally": "Hyderabad",
  "gachibowli": "Hyderabad",
  "madhapur": "Hyderabad",
  "hitec city": "Hyderabad",
  "hanumakonda": "Warangal",
  "hanamkonda": "Warangal",
  "warangal urban": "Warangal",
  "warangal rural": "Warangal",
  "kazipet": "Warangal",

  // Tamil Nadu
  "madras": "Chennai",
  "chennai district": "Chennai",
  "chennai metropolitan": "Chennai",
  "tambaram": "Chennai",
  "avadi": "Chennai",
  "kovai": "Coimbatore",
  "tiruchirappalli": "Trichy",
  "tiruchirapalli": "Trichy",

  // West Bengal
  "calcutta": "Kolkata",
  "kolkata district": "Kolkata",
  "kolkata metropolitan": "Kolkata",
  "howrah": "Kolkata",
  "salt lake": "Kolkata",
  "new town": "Kolkata",

  // Andhra Pradesh
  "vishakhapatnam": "Visakhapatnam",
  "vizag": "Visakhapatnam",
  "visakhapatnam district": "Visakhapatnam",
  "waltair": "Visakhapatnam",
  "bezawada": "Vijayawada",
  "krishna": "Vijayawada",
  "krishna district": "Vijayawada",
  "ntr district": "Vijayawada",
  "guntur district": "Guntur",
  "amaravati": "Vijayawada",

  // Gujarat
  "amdavad": "Ahmedabad",
  "ahmedabad district": "Ahmedabad",
  "baroda": "Vadodara",

  // Kerala
  "cochin": "Kochi",
  "ernakulam": "Kochi",
  "ernakulam district": "Kochi",
  "trivandrum": "Thiruvananthapuram",
  "calicut": "Calicut",
  "kozhikode": "Calicut",

  // Uttar Pradesh
  "prayagraj": "Allahabad",
  "allahabad district": "Allahabad",
  "varanasi district": "Varanasi",
  "banaras": "Varanasi",
  "kashi": "Varanasi",
  "lucknow district": "Lucknow",
  "kanpur nagar": "Kanpur",
  "kanpur dehat": "Kanpur",

  // Rajasthan
  "pink city": "Jaipur",
  "jaipur district": "Jaipur",

  // Punjab / Haryana / Chandigarh
  "mohali": "Chandigarh",
  "panchkula": "Chandigarh",
  "sas nagar": "Chandigarh",
  "tricity": "Chandigarh",

  // Other Capitals & Hubs
  "bhopal district": "Bhopal",
  "indore district": "Indore",
  "patna district": "Patna",
  "ranchi district": "Ranchi",
  "bhubaneswar city": "Bhubaneswar",
  "khordha": "Bhubaneswar",
  "cuttack district": "Cuttack",
  "kamrup metropolitan": "Guwahati",
  "kamrup": "Guwahati",
  "east khasi hills": "Shillong",
  "west tripura": "Agartala",
  "imphal west": "Imphal",
  "imphal east": "Imphal",
  "east gangtok": "Gangtok",
  "east sikkim": "Gangtok",
  "srinagar district": "Srinagar",
  "jammu district": "Jammu",
  "dehra doon": "Dehradun",
  "pondicherry": "Puducherry",
};

function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function matchCity(detectedName: string): City | null {
  if (!detectedName) return null;
  const cleaned = detectedName.trim().replace(/^(the|city\s+of)\s+/i, "");
  const lower = cleaned.toLowerCase().trim();
  if (!lower || lower.length < 2) return null;

  // Ignore generic country/region strings
  if (lower === "india" || lower === "in" || lower === "asia" || lower === "south asia") return null;

  // 1. Direct match against CITIES list (case-insensitive)
  const direct = CITIES.find(c => c.toLowerCase() === lower);
  if (direct && direct !== "All India") return direct;

  // 2. Direct alias match
  const alias = CITY_ALIASES[lower];
  if (alias) {
    const matched = CITIES.find(c => c.toLowerCase() === alias.toLowerCase());
    if (matched && matched !== "All India") return matched;
  }

  // 3. Word-boundary match against CITIES list (e.g. "Greater Mumbai" -> "Mumbai", "Kolkata City" -> "Kolkata")
  for (const city of CITIES) {
    if (city === "All India" || city.length < 3) continue;
    const cityLower = city.toLowerCase();
    const regex = new RegExp(`(^|[^a-zA-Z0-9])${escapeRegex(cityLower)}([^a-zA-Z0-9]|$)`, "i");
    if (regex.test(lower)) {
      return city;
    }
  }

  // 4. Word-boundary match against CITY_ALIASES (e.g. "Bangalore Urban" -> "Bengaluru", "Kukatpally Housing Board" -> "Hyderabad")
  for (const [aliasKey, targetCity] of Object.entries(CITY_ALIASES)) {
    if (aliasKey.length < 3) continue;
    const regex = new RegExp(`(^|[^a-zA-Z0-9])${escapeRegex(aliasKey)}([^a-zA-Z0-9]|$)`, "i");
    if (regex.test(lower)) {
      const matched = CITIES.find(c => c.toLowerCase() === targetCity.toLowerCase());
      if (matched && matched !== "All India") return matched;
    }
  }

  return null;
}

/** Try matching from multiple candidate names in order, return the first valid match */
export function matchCityFromCandidates(candidates: (string | undefined | null)[]): City | null {
  for (const name of candidates) {
    if (!name) continue;
    const matched = matchCity(name);
    if (matched) return matched;
  }
  return null;
}

function getSavedCity(): City | null {
  try {
    const saved = localStorage.getItem(CITY_STORAGE_KEY);
    if (saved) {
      const matched = CITIES.find(c => c === saved);
      if (matched) return matched;
    }
  } catch {
    // localStorage unavailable
  }
  return null;
}

function saveCity(city: City) {
  try {
    localStorage.setItem(CITY_STORAGE_KEY, city);
  } catch {
    // localStorage unavailable
  }
}

/** Reverse geocode coordinates using BigDataCloud (fast, accurate for India) + Nominatim fallback */
async function reverseGeocodeCoords(latitude: number, longitude: number): Promise<City | null> {
  // Provider 1: BigDataCloud Reverse Geocode (free client tier, detailed administrative hierarchy)
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    const res = await fetch(
      `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`,
      { signal: controller.signal }
    );
    clearTimeout(timeout);
    if (res.ok) {
      const data = await res.json();
      const adminNames = Array.isArray(data?.localityInfo?.administrative)
        ? data.localityInfo.administrative.map((a: any) => a?.name).filter(Boolean)
        : [];
      const candidates = [
        data?.city,
        data?.locality,
        ...adminNames,
      ];
      const matched = matchCityFromCandidates(candidates);
      if (matched) return matched;
    }
  } catch {
    // BigDataCloud reverse geocode failed, try Nominatim
  }

  // Provider 2: OpenStreetMap Nominatim
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=14&addressdetails=1`,
      {
        headers: { "Accept-Language": "en" },
        signal: controller.signal,
      }
    );
    clearTimeout(timeout);
    if (res.ok) {
      const data = await res.json();
      const addr = data?.address;
      if (addr || data?.name) {
        const candidates = [
          data?.name,
          addr?.city,
          addr?.town,
          addr?.municipality,
          addr?.suburb,
          addr?.city_district,
          addr?.neighbourhood,
          addr?.village,
          addr?.district,
          addr?.state_district,
          addr?.county,
        ];
        const matched = matchCityFromCandidates(candidates);
        if (matched) return matched;
      }
    }
  } catch {
    // Nominatim failed
  }

  return null;
}

/** Multi-provider IP-based geolocation fallback */
async function detectCityByIP(): Promise<City | null> {
  // Provider 1: ipwho.is
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    const res = await fetch(
      "https://ipwho.is/?fields=success,city,region,country,latitude,longitude",
      { signal: controller.signal }
    );
    clearTimeout(timeout);
    if (res.ok) {
      const data = await res.json();
      if (data?.success) {
        // Direct candidate match
        const matched = matchCityFromCandidates([data.city, data.region]);
        if (matched) return matched;

        // If coordinates provided, reverse geocode coordinates for finer resolution
        if (typeof data.latitude === "number" && typeof data.longitude === "number") {
          const revMatched = await reverseGeocodeCoords(data.latitude, data.longitude);
          if (revMatched) return revMatched;
        }
      }
    }
  } catch {
    // ipwho.is failed, continue to fallback
  }

  // Provider 2: BigDataCloud client IP geocoding
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    const res = await fetch(
      "https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=en",
      { signal: controller.signal }
    );
    clearTimeout(timeout);
    if (res.ok) {
      const data = await res.json();
      const adminNames = Array.isArray(data?.localityInfo?.administrative)
        ? data.localityInfo.administrative.map((a: any) => a?.name).filter(Boolean)
        : [];
      const candidates = [data?.city, data?.locality, ...adminNames];
      const matched = matchCityFromCandidates(candidates);
      if (matched) return matched;
    }
  } catch {
    // BigDataCloud IP failed
  }

  // Provider 3: ipapi.co
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    const res = await fetch("https://ipapi.co/json/", { signal: controller.signal });
    clearTimeout(timeout);
    if (res.ok) {
      const data = await res.json();
      const matched = matchCityFromCandidates([data?.city, data?.region]);
      if (matched) return matched;
    }
  } catch {
    // ipapi.co failed
  }

  return null;
}

/** Accurate Browser GPS Geolocation + Reverse Geocoding */
async function detectCityByGeolocation(enableHighAccuracy = true): Promise<City | null> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          const matched = await reverseGeocodeCoords(latitude, longitude);
          if (matched) {
            resolve(matched);
            return;
          }
        } catch {
          // Geolocation reverse geocoding failed
        }
        resolve(null);
      },
      () => {
        // User denied permission or error
        resolve(null);
      },
      { enableHighAccuracy, timeout: 8000, maximumAge: 300000 }
    );
  });
}

type Ctx = {
  category: Category;
  city: City;
  setCategory: (c: Category) => void;
  setCity: (c: City) => void;
  isDetectingLocation: boolean;
  detectLocation: (requestGPS?: boolean) => Promise<City | null>;
};

const MarketplaceCtx = createContext<Ctx | null>(null);

export function MarketplaceProvider({ children }: { children: ReactNode }) {
  const [category, setCategory] = useState<Category>("All Categories");
  const [city, setCityState] = useState<City>(() => getSavedCity() || "All India");
  const [isDetectingLocation, setIsDetectingLocation] = useState(false);

  // Wrapper that also persists city to localStorage
  const setCity = useCallback((c: City) => {
    setCityState(c);
    saveCity(c);
  }, []);

  // Callable location detection helper (used by modal or manual trigger)
  const detectLocation = useCallback(async (requestGPS = true): Promise<City | null> => {
    setIsDetectingLocation(true);
    try {
      let detectedCity: City | null = null;

      // When requested with GPS, try accurate device geolocation first
      if (requestGPS && navigator.geolocation) {
        detectedCity = await detectCityByGeolocation(true);
      }

      // If GPS not available / denied / didn't match, fallback to IP detection
      if (!detectedCity) {
        detectedCity = await detectCityByIP();
      }

      if (detectedCity) {
        setCityState(detectedCity);
        saveCity(detectedCity);
        return detectedCity;
      }
    } finally {
      setIsDetectingLocation(false);
    }
    return null;
  }, []);

  // Auto-detect location on first visit if no city is explicitly chosen
  useEffect(() => {
    // If user already chose/saved a city, keep their preference
    if (getSavedCity()) return;

    let cancelled = false;
    setIsDetectingLocation(true);

    (async () => {
      let detectedCity: City | null = null;

      // Check if geolocation permission is already granted
      try {
        if (navigator.permissions && navigator.permissions.query) {
          const status = await navigator.permissions.query({ name: "geolocation" as PermissionName });
          if (status.state === "granted") {
            detectedCity = await detectCityByGeolocation(false);
          }
        }
      } catch {
        // Permissions query not supported, continue
      }

      // Fallback to seamless IP geolocation if not detected
      if (!detectedCity && !cancelled) {
        detectedCity = await detectCityByIP();
      }

      if (!cancelled) {
        if (detectedCity) {
          setCityState(detectedCity);
          saveCity(detectedCity);
        }
        setIsDetectingLocation(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({ category, city, setCategory, setCity, isDetectingLocation, detectLocation }),
    [category, city, setCity, isDetectingLocation, detectLocation]
  );
  return <MarketplaceCtx.Provider value={value}>{children}</MarketplaceCtx.Provider>;
}

export function useMarketplace() {
  const ctx = useContext(MarketplaceCtx);
  if (!ctx) throw new Error("useMarketplace must be used inside MarketplaceProvider");
  return ctx;
}